import Vue from 'vue';
import store from '@/store';
import { Article } from '@/models/article/Article';
import { commitSetArticleEditorIsVideoProcessing } from '@/store/commits/articleEditorCommits';

/**
 * Switches the edit page to the upload view, whose iframe lets the extension attach the recording,
 * once the article has a pending upload and the extension has answered the handshake. Either can
 * arrive first. Without the extension the page keeps the editor.
 */
export const watchPendingExtensionUpload = (vm: Vue, getArticle: () => Article | null) => {
  vm.$watch(
    () => !!getArticle()?.hasPendingExtensionUpload() && !!store.state.extension.id,
    (isPending: boolean) => {
      if (isPending) {
        commitSetArticleEditorIsVideoProcessing(true);
      }
    }
  );
};
